'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.botTypingStates = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botTypingStates = exports.botTypingStates = (0, _get2.default)('botTypingStates');


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/selectors/botTypingStates.js
// module id = 638
// module chunks = 2 3